module.exports = __webpack_public_path__ + "static/media/electricrevolution.40402e28.jpg";